export default __webpack_public_path__ + "static/media/Background 5_00023.75dabf96.png";